export default __webpack_public_path__ + "static/media/ki.23a93c2f.svg";